import { render, staticRenderFns } from "./ProductMaterials.vue?vue&type=template&id=5307449f&"
import script from "./ProductMaterials.vue?vue&type=script&lang=js&"
export * from "./ProductMaterials.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports